export default class CardComponent {
    constructor(identifier, options = {}, experiments = null) {
        this.template = Handlebars.compile(document.getElementById(`${identifier}-template`).innerHTML);
        this.experiments = experiments ?? false;
        this.options = options;
        this.identifier = identifier;
    }

    createHtml(data) {
        const html = this.template({...data, ...this.getOptions()});
        return html;
    }

    /**
     * Trying to add parameters to a specific template? Start here.
     * If you want to do it for ALL card components, based on the seller's data passed into createHtml, do it here
     *
     * If you want to target a specific component, override this function in that components definition.
     *  Be sure to call super.getOptions() within the override so you dont miss out on any modifications being done globally!
     *
     * For example, to redirect a seller's profile URL to a new URL structure, you could edit this function to set
     *    this.options.public_url = 'www.google.com';
     * To replace the avatar of 5 star rated Personal Trainers, you would override getOptions within Avatar.js  to read something like:
     *    getOptions(createHtmlData) {
     *        super.getOptions(createHtmlData);
     *        if (createHtmlData.attributes.top_categories.includes('Personal Trainers') && createHtmlData.attributes.reviews_score > 4.5){
     *           this.options.avatar_url = 'https://cdn.cnn.com/cnnnext/dam/assets/190819140518-he-man-exlarge-169.jpg'
     *        }
     *        return this.options;
     *    }
     *
     *  If both were done, then 5 star personal trainers would all show He Man as their avatar,
     *  and clicking ANY sellers avatar would take you to google.
     *
     * @param createHtmlData {{}} the attributes that will be passed to handlebars to output this component, generally a curated set of data about the seller being output
     * @returns {{}} a set of data that will be appended onto the above attributes being passed to handlebars for rendering this component
     */
    getOptions(createHtmlData) {
        if (this.experiments && Array.isArray(this.experiments)) {
            /*
            To manipulate this.options for ALL cardComponents, do that in here (based on experiments)
            */

        }
        return this.options; // DO NOT modify the return statement
    }

    getExperimentVariant(experimentName) {
        let exp = this.experiments.find(item => item.name === experimentName) || {};
        return exp.variant ?? 0;
    }
}
